import { Routes } from '@angular/router';
import { requireAuthenticatedGuard, requirePermissionGuard } from './core/routing';
import { LayoutComponent } from './layout/layout.component';


export const routes: Routes = [
    /* "Home" - Will use canActivate to determine if it should go to the Sign In page or some home page. */
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/home'
    },
    {
        path: 'reports',
        canActivate: [requireAuthenticatedGuard],
        loadChildren: () => import('./domains/reporting/reporting.routes').then((reports) => reports.routes)
    },
    {
        path: 'admin',
        component: LayoutComponent,
        canActivate: [requireAuthenticatedGuard],
        children: [
            {
                path: 'subscribers',
                loadChildren: () => import('./domains/subscriber/subscriber.routes').then((subscriber) => subscriber.routes)
            },
            {
                path: 'source-systems',
                loadChildren: () => import('./domains/source-system/source-system.routes').then((sourceSystem) => sourceSystem.routes)
            }
        ]
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [requireAuthenticatedGuard],
        children: [
            {
                path: 'home',
                title: 'Home',
                loadComponent: () => import('./domains/dashboard/dashboard-page/dashboard-page.component').then((dashboard) => dashboard.DashboardPageComponent)
            },
            {
                path: 'dashboards',
                loadChildren: () => import('./domains/dashboards/dashboards.routes').then((dashboards) => dashboards.routes)
            },
            {
                path: 'alerts',
                loadChildren: () => import('./domains/alerts/alerts.routes').then((alerts) => alerts.routes)
            },
            {
                path: 'tank-monitors',
                loadChildren: () => import ('./domains/tank-monitor/tank-monitor.routes'). then((tankMonitors) => tankMonitors.routes)
            },
            {
                path: 'test',
                title: 'Developer Test Page',
                canActivate: [requirePermissionGuard('sysAdmin')],
                loadComponent: () => import('./layout/test-content-prime-ng/test-content-prime-ng.component').then((testContent) => testContent.TestContentComponent)
            },
            {
                path: 'users',
                loadChildren: () => import('./domains/user/user.routes').then((user) => user.routes)
            },
        ]
    },
    {
        path: 'auth',
        loadChildren: () => import('./domains/auth/auth.routes').then((auth) => auth.routes)
    },
    {
        path: '**',
        redirectTo: '/auth/not-found'
    }
];
